var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronLast = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 18.75C16.1642 18.75 16.5 18.4142 16.5 18V6C16.5 5.58579 16.1642 5.25 15.75 5.25C15.3358 5.25 15 5.58579 15 6L15 18C15 18.4142 15.3358 18.75 15.75 18.75ZM6.21967 17.4697C5.92678 17.7626 5.92678 18.2374 6.21967 18.5303C6.51256 18.8232 6.98744 18.8232 7.28033 18.5303L13.2803 12.5303C13.5732 12.2374 13.5732 11.7626 13.2803 11.4697L7.28033 5.46967C6.98744 5.17678 6.51256 5.17678 6.21967 5.46967C5.92678 5.76256 5.92678 6.23744 6.21967 6.53033L11.6893 12L6.21967 17.4697Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronLast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-last.d40246ba9c4f8158cec4b47200935d97.svg";